import { render, staticRenderFns } from "./RestriccionesSeguimientosPagination.vue?vue&type=template&id=6707cdfd&"
import script from "./RestriccionesSeguimientosPagination.vue?vue&type=script&lang=js&"
export * from "./RestriccionesSeguimientosPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports